import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cac5834"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dashboard-panel report-export",
  "aria-labelledby": "report-export-title"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<header class=\"report-export__header\" data-v-1cac5834><span class=\"report-export__icon\" data-v-1cac5834><i class=\"ph ph-file-xls\" aria-hidden=\"true\" data-v-1cac5834></i></span><div data-v-1cac5834><span class=\"report-export__eyebrow\" data-v-1cac5834>Seus dados com você</span><h2 id=\"report-export-title\" data-v-1cac5834>Relatório em Excel</h2></div></header><p class=\"report-export__description\" data-v-1cac5834>Escolha o mês para baixar suas entradas, gastos e recorrentes previstos, com totais e saldo calculados.</p>", 2)
const _hoisted_4 = { for: "report-month" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mês", -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { for: "report-year" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ano", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled", "aria-busy"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-export__hint" }, "Arquivo .xlsx com resumo e abas separadas. Recorrentes são previsões, conforme os cadastros atuais.", -1))
const _hoisted_13 = {
  key: 0,
  class: "report-export__feedback report-export__feedback--error",
  role: "alert"
}
const _hoisted_14 = {
  key: 1,
  class: "report-export__feedback",
  role: "status"
}
const _hoisted_15 = {
  key: 2,
  class: "report-export__feedback",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "report-export__form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportReport && _ctx.exportReport(...args)), ["prevent"]))
    }, [
      _createElementVNode("label", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          id: "report-month",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
          disabled: _ctx.exporting,
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.value,
              value: item.value
            }, _toDisplayString(item.label), 9, _hoisted_7))
          }), 128))
        ], 8, _hoisted_6), [
          [
            _vModelSelect,
            _ctx.month,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("label", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          id: "report-year",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.year) = $event)),
          type: "number",
          min: "2000",
          max: "2100",
          step: "1",
          inputmode: "numeric",
          disabled: _ctx.exporting,
          required: ""
        }, null, 8, _hoisted_10), [
          [
            _vModelText,
            _ctx.year,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        disabled: _ctx.exporting,
        "aria-busy": _ctx.exporting
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.exporting ? 'ph ph-spinner report-export__spinner' : 'ph ph-download-simple'),
          "aria-hidden": "true"
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.exporting ? 'Gerando planilha…' : 'Baixar Excel'), 1)
      ], 8, _hoisted_11)
    ], 32),
    _hoisted_12,
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.error), 1))
      : (_ctx.success)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.success), 1))
        : (_ctx.exporting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Preparando todos os lançamentos do mês selecionado…"))
          : _createCommentVNode("", true)
  ]))
}